{
  "title": "How to Set Up Manual Score Entry for a Round",
  "description": "Let staff enter add, deduct or record-only fields for a round and include them in the results.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Begin",
    "Steps",
    "Afterward",
    "FAQ"
  ],
  "summary": "Afterward, the round scores according to the mode you chose: judges only, staff input only, or judges plus staff input, and staff can enter each team's values on the Manual entry page.",
  "roleNote": "Setup: competition admin (competition.manage). Entry: competition admin or staff (score.manual.enter)",
  "prerequisites": [
    "The round exists",
    "Results are not yet locked or published (after locking, the mode, fields and entries can no longer change)"
  ],
  "pathLabel": "Organizer console → Rounds; Review → Manual entry",
  "steps": [
    {
      "title": "1. Choose the scoring input",
      "description": "On the Rounds page, pick the round's \"Scoring input\": \"Judges only\" (default, same as before), \"Staff input only\" (judges do not score), or \"Judges plus staff input\" (starts from the judges' average, then applies staff additions and deductions). It takes effect once you save the round."
    },
    {
      "title": "2. Add manual input fields",
      "description": "When the mode includes staff, the round card shows \"Manual input fields\". Enter a field name, minimum, maximum and how it counts: Add (added to the total), Deduct (enter a positive number; it is subtracted) or Record only (no effect on the score). A field that already has entries can only be renamed, not deleted or given a new range."
    },
    {
      "title": "3. Open the round and let staff enter values",
      "description": "The round must be Open or Judging. Staff go to Review → Manual entry, pick the round, type values on each team's card and press \"Save this team\". Values outside the range cannot be saved."
    },
    {
      "title": "4. Calculate and review the detail",
      "description": "Calculate on the Results page. For \"Judges plus staff input\" the final score is the judges' average plus the additions minus the deductions, with a missing entry counting as 0. For \"Staff input only\" only the manual values count, and a submission missing any add or deduct field is excluded. The submission's \"Score detail by source\" labels each score as Judge or Staff input and can expand the change history (who, when, value before and after)."
    }
  ],
  "afterward": [
    "The results page shows the judges' score and the manual adjustment",
    "After results are locked, the mode, fields and entries can no longer change"
  ],
  "nextSteps": "To see one submission's scores, see \"How to View a Submission's Scores\". To calculate and publish results, see \"How to calculate, lock and publish results\".",
  "faq": [
    {
      "q": "Can I still assign judges to a staff-input-only round?",
      "a": "No. That round does not accept judge scores; new assignments and auto-distribute are rejected. Existing assignments are not cancelled automatically, but judges can no longer submit scores."
    },
    {
      "q": "Can staff reopen a judge's score?",
      "a": "No. The manual entry permission (score.manual.enter) is separate from score management (score.manage); staff can only enter the manual fields."
    },
    {
      "q": "What if a value was entered wrongly?",
      "a": "Until results are locked, staff can correct the value directly. Every correction is recorded with who changed it, when, and the value before and after."
    },
    {
      "q": "Are these settings carried when I export or clone a competition?",
      "a": "Yes. The scoring input mode and manual fields are included in export, clone and templates, but never any entered values."
    }
  ]
}
